import { SchedulingModule } from "@/store/modules/SchedulingModule";

export function getTravelTimeBetweenTasksInMs() {
  return (
    SchedulingModule.schedulingSettings.travelTimeSettings
      .defaultTravelTimeBetweenTasksInMin * 60000
  );
}

export function getTravelTimeToDepotInMs() {
  return (
    SchedulingModule.schedulingSettings.travelTimeSettings
      .defaultTravelTimeBetweenTaskAndDepotInMin * 60000
  );
}
